import { AssetTypeResolverBase } from './asset-type.resolver.base';
import { AssetTypeService } from './asset-type.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class AssetTypeResolver extends AssetTypeResolverBase {

  constructor(protected service: AssetTypeService) {
    super(service);
  }
}



